module.exports = __webpack_public_path__ + "img/operational_planning_de.47743f71.svg";